import { create } from 'zustand';

type MobileNavState = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

export const useMobileNavStore = create<MobileNavState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
